import type { AxiosError } from 'axios';
import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// API Endpoints
import { HASHTAGS } from '@/routes/apiEndpoints';

export type HashtagType = {
    created_at: string;
    id: string;
    is_favorite: boolean;
    name: string;
    rate_limit_exceeded?: boolean;
    updated_at: string;
};

export type MutateHashtagsType = KeyedMutator<HashtagType[]>;

type UseHashtagsType = {
    activeSPID?: number;
    options?: SWRConfiguration<HashtagType[], AxiosError<Error>>;
};
const useHashtags = ({ activeSPID, options }: UseHashtagsType) => {
    const {
        data: hashtags,
        mutate: mutateHashtags,
        error: errorHashtags,
        isLoading
    } = useSWR<HashtagType[], AxiosError<Error>>(
        injectEndpointUrlParams(HASHTAGS, { SPID: activeSPID }),
        (url) => get(url).then((res) => res.data?.hashtags),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        hashtags,
        mutateHashtags,
        errorHashtags,
        isLoading
    };
};

export default useHashtags;
